import { useCallback, useContext } from 'react'
import { useMutation } from '@apollo/react-hooks'

import ACTIVATE from './queries/Activate.gql'
import REGISTER from './queries/Register.gql'
import AUTHENTICATE from './queries/Authenticate.gql'
import { AuthContext } from './Provider'

export const useRegister = options => {
  const [register, { loading, error, data }] = useMutation(REGISTER, options)

  const registerHelper = useCallback(
    ({ username, email, password }) =>
      register({ variables: { username, email, password } }),
    [register]
  )

  const success = data?.register?.success

  return [registerHelper, { loading, error, success }]
}

export const useActivate = options => {
  const [activate, { loading, error, data }] = useMutation(ACTIVATE, options)

  const activateHelper = useCallback(
    ({ activationToken, userId }) =>
      activate({ variables: { activationToken, userId } }),
    [activate]
  )

  const success = data?.activate?.success

  return [activateHelper, { loading, error, success }]
}

export const useCurrentUserId = () => {
  const { userId } = useContext(AuthContext)

  return userId
}

export const useCurrentUserIsEditor = () => {
  const { editor } = useContext(AuthContext)
  
  return editor
}

export const useLogin = () => {
  const [authenticate, state] = useMutation(AUTHENTICATE)
  const { postLogin } = useContext(AuthContext)

  const login = useCallback(
    async ({ username, password }) => {
      const { data } = await authenticate({ variables: { username, password } })
      await postLogin(data.tokenAuth)
    },
    [authenticate, postLogin]
  )

  return [login, state]
}

export const useLogout = () => {
  const { logout } = useContext(AuthContext)

  return logout
}

export const useRenewTokens = () => {
  const { renewTokens } = useContext(AuthContext)

  return renewTokens
}
